// extracted by mini-css-extract-plugin
export default {"wrapper":"SliderUi_wrapper__Yxh6i","label":"SliderUi_label__njRjs","SliderUi":"SliderUi_SliderUi__GkMg5"};